export const permissionCol = [
  { name: "Permission Name", index: "permission_name", id: 1 },
  { name: "Permission Description", index: "permission_description", id: 1 }
];
